import React, {useEffect, useState} from 'react';
import style from './header.module.css'
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import {Link, useLocation, useNavigate} from "react-router-dom";
import HeaderDropdown from "../HeaderDropdown/HeaderDropdown";
import {SERVICES,
    PERSONAL,
    COMPANY,
    CONTACT_US,
    ABOUT_US,
    HOME} from "../../constants/RoutesConstants";
import {useAppSelector} from "../../hooks/redux";
import s from "../../pages/PersonalAccount/PersonalAccount.module.css";
import { brandTheme } from '../../config/config';
import MyBtn from '../ui/MyBtn/MyBtn';
import { DropDown } from '../ui/DropDown/DropDown';

const Header = () => {

    const navigate = useNavigate()
    const isLogin = useAppSelector(state => state.userReducer.user.userToken)
    const firstName: string | null = useAppSelector(state => state.userReducer.user.userData.firstName)
    const lastName: string | null = useAppSelector(state => state.userReducer.user.userData.lastName)
    const companyName: string | null = useAppSelector(state => state.userReducer.user.userData.companyName)
    const verifyStatus: string | null = useAppSelector(state => state.userReducer.user.flags.kycStatus)

    console.log(`viryfyStatus`, verifyStatus)


    const location = useLocation()

    const [isHeaderShow, setIsHeaderShow] = useState(true)

    useEffect(() => {

        if (
            location.pathname.includes("login") ||
            location.pathname.includes("sign-up") ||
            location.pathname.includes("personal_account")
            ) {
            setIsHeaderShow(false)
        } else {
            setIsHeaderShow(true)
        }
    },[location.pathname])

    const setActiveTab = (pathname: string) => {
        return location.pathname.includes(pathname)
    }
   
    const backToPersonalAccount = () => {
        
        if (verifyStatus === "Confirmed") {
            navigate('/personal_account/accounts')
        } else {
            navigate("/personal_account/personal/settings");
        }
    }

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLinkClick = () => {
        setIsOpen(false);
       
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        handleLinkClick()
    };

     return (
        <>
            {
                isHeaderShow &&
                <header className={style.container}>
                    <div className={style.block}>

                        <div className={style.logo_block}>
                            <Link className={style.header_link} to="/">
                                <div className={style.logo}></div>
                            </Link>
                        </div>

                        
                    </div>
                    <div className={style.links_block}>
                            <Link  className={`${style.header_link} ${location.pathname === HOME ? style.header_link_active : ''}`} 
                                  to={HOME}
                            >
                                Home
                            </Link>
                            <DropDown 
                            
                                closeMenu={closeMenu}
                                buttonLabel='Services'
                                handleLinkClick={handleLinkClick}
                                isOpen={isOpen}
                                setIsOpen={setIsOpen}
                                items={[
                                    { title: 'Our Services', url: "/services"},
                                    { title: 'Cards', url: "/services-cards"},
                                    { title: 'Commercial Banking', url: "/commercial-banking"},
                                    { title: 'Private Banking', url: "/private-banking"},
                                    { title: 'Saving Account', url: "/saving-accounts"},
                                    { title: 'Digital Assets Banking', url: "/digital-assets-banking"},
                                ]}
                            />
                            {/* <Link className={`${style.header_link} ${setActiveTab(SERVICES) ? style.header_link_active : ''}`} 
                                  to={SERVICES}
                            >
                                Services
                            </Link> */}
                            <Link className={`${style.header_link} ${setActiveTab(PERSONAL) ? style.header_link_active : ''}`} 
                                  to={PERSONAL}
                            >
                                Personal
                            </Link>
                            <Link className={`${style.header_link} ${setActiveTab(COMPANY) ? style.header_link_active : ''}`} 
                                  to={COMPANY}
                            >
                                Company
                            </Link>
                            <Link className={`${style.header_link} ${setActiveTab(CONTACT_US) ? style.header_link_active : ''}`} 
                                  to={CONTACT_US}
                            >
                                Contact Us
                            </Link>
                            <Link className={`${style.header_link} ${setActiveTab(ABOUT_US) ? style.header_link_active : ''}`} 
                                  to={ABOUT_US}
                            >
                                About Us
                            </Link>
                        </div>
                    {
                       isLogin  !== "" ?
                            <div onClick={() => backToPersonalAccount()} className={style.round}>
                                <div className={style.user_typography}>
                                    <div><b><p className={style.name}>{firstName} {lastName} {companyName}</p></b></div>
                                    {/* <div><p className={style.id}>ID: {clientId}</p></div> */}
                                </div>
                                <div className={style.user}></div>
                            </div>
                        : <div className={style.buttons_block}>
                            <div className={style.button_wrapper_short}>
                                <Link to={"/login"}>
                                    <TransparentButton title={"Sign In"}/>
                                </Link>
                            </div>
                            <div className={style.button_wrapper}>
                                <Link to={"/sign-up"}>
                                    <MyBtn title={"Open Account"}/>
                                </Link>
                            </div>
                        </div>
                    }
                </header>
            }
        </>
    );
};

export default Header;
